export default "__VITE_ASSET__CFQyu1w2__"